import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

interface AnimatedElementProps {
  children: React.ReactNode;
  from: "left" | "right" | "bottom"; 
}

const AnimatedElement: React.FC<AnimatedElementProps> = ({ children, from }) => {
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let initialPosition: { x?: string; y?: string } = {};
    if (from === "left") {
      initialPosition = { x: "-100%", y: "0%" };
    } else if (from === "right") {
      initialPosition = { x: "100%", y: "0%" };
    } else if (from === "bottom") {
      initialPosition = { x: "0%", y: "100%" };
    }

    if (elementRef.current) {
      gsap.fromTo(
        elementRef.current,
        { ...initialPosition, opacity: 0 },
        {
          x: "0%",
          y: "0%",
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: elementRef.current,
            start: "top 90%", 
            end: "top 50%",  
            scrub: false,    // Pas de synchronisation avec le scroll
          },
        }
      );
    }
  }, [from]);

  return (
    <div ref={elementRef} className="animated-element">
      {children}
    </div>
  );
};

export default AnimatedElement;